// extracted by mini-css-extract-plugin
export default {"modalFooter":"styles_modalFooter__AqViX"};